import styled from 'styled-components';

export const MealPeriodDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MealPeriodTitle = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;
